<template>
    <div class="percent-input">
        <input type="number" class="form-control" v-model="postValue"/>
        <input type="hidden" :name="name" :value="postValue * 0.01" />
    </div>
</template> 

<script>
export default {
    name: 'percent',
    props: {
        name: String,
        value: String
    },
    data() {
        return {
            postValue: undefined
        }
    },
    mounted() {
        this.postValue = Math.round((this.value || 0) * 100);
    }
}
</script>